import { PoolUomDroOpts } from "presentation/constant/DropDownOptions/Company/PoolUomDroOpts";
import { useChargeDetailVM } from "presentation/hook/ChargeDetailMaintenance/useChargeDetailVM";
import { ChargeDetailModel } from "presentation/model/ChargeDetailMaintenance/ChargeDetailModel";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import NumberInputComponent from "presentation/view/components/NumberInputComponent";
import { useCallback } from "react";
import { FieldType, IFieldValue } from "veronica-ui-component/dist/component/core";

export const EmptyQtyAccordion = ({ chargeDetailState }: { chargeDetailState: ChargeDetailModel }) => {
    const chargeBatchUpdate = chargeDetailState.chargeBatchUpdate
    const chargeDetailVM = useChargeDetailVM();
    const onNumberFieldChange = useCallback((event: React.ChangeEvent<HTMLInputElement>, fieldName: string) => {
        chargeDetailVM.onInputTextChange(event, fieldName, chargeBatchUpdate, 'chargeBatchUpdate');
    }, [chargeDetailVM, chargeBatchUpdate]);
    return (
        <>
            <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                {/* <div className='im-flex-row-item' style={{ width: "150px" }}>
                    <NbisCommonField
                        errorMessages={{}}
                        isReadOnly={false}
                        isShowOptional={false}
                        readOnlyValue={chargeBatchUpdate.chargeUom ?? ""}
                        fieldValue={chargeBatchUpdate.chargeUom}
                        fieldLabel={"Charge UOM"}
                        isSaveClicked={false}
                        fieldType={FieldType.DROPDOWN}
                        fieldKey={'chargeUom'}
                        maxLength={60}
                        options={PoolUomDroOpts().getPoolUomModel()}
                        requiredFieldList={[]}
                        onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                            chargeDetailVM.onChargeBatchUpdateFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
                </div> */}

                <div className='im-flex-row-item' style={{ width: "150px" }}>
                    <NbisCommonField
                        errorMessages={{}}
                        isReadOnly={false}
                        isShowOptional={false}
                        readOnlyValue={chargeBatchUpdate.poolUom ?? ""}
                        fieldValue={chargeBatchUpdate.poolUom}
                        fieldLabel={"Charge UOM"}
                        isSaveClicked={false}
                        fieldType={FieldType.DROPDOWN}
                        fieldKey={'poolUom'}
                        maxLength={60}
                        options={PoolUomDroOpts().getPoolUomModel()}
                        requiredFieldList={[]}
                        onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                            chargeDetailVM.onChargeBatchUpdateFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
                </div>
            </div>
            <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                <div className='im-flex-row-item'>
                    <NumberInputComponent
                        label={`20'`}
                        width='150px'
                        fieldName={"empty20Qty"}
                        value={chargeBatchUpdate.empty20Qty || ''}
                        disabled={false}
                        decimalPlaces={2}
                        onChange={(e: any) => onNumberFieldChange(e, 'empty20Qty')}
                    />
                </div>
                <div className='im-flex-row-item'>
                    <NumberInputComponent
                        label={`40'`}
                        width='150px'
                        fieldName={"empty40Qty"}
                        value={chargeBatchUpdate.empty40Qty || ''}
                        disabled={false}
                        decimalPlaces={2}
                        onChange={(e: any) => onNumberFieldChange(e, 'empty40Qty')}
                    />
                </div>
            </div>
            <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                <div className='im-flex-row-item'>
                    <NumberInputComponent
                        label={`45'`}
                        width='150px'
                        fieldName={"empty45Qty"}
                        value={chargeBatchUpdate.empty45Qty || ''}
                        disabled={false}
                        decimalPlaces={2}
                        onChange={(e: any) => onNumberFieldChange(e, 'empty45Qty')}
                    />
                </div>
                <div className='im-flex-row-item'>
                    <NumberInputComponent
                        label={`48'`}
                        width='150px'
                        fieldName={"empty48Qty"}
                        value={chargeBatchUpdate.empty48Qty || ''}
                        disabled={false}
                        decimalPlaces={2}
                        onChange={(e: any) => onNumberFieldChange(e, 'empty48Qty')}
                    />
                </div>
            </div>
            <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                <div className='im-flex-row-item'>
                    <NumberInputComponent
                        label={`53'`}
                        width='150px'
                        fieldName={"empty53Qty"}
                        value={chargeBatchUpdate.empty53Qty || ''}
                        disabled={false}
                        decimalPlaces={2}
                        onChange={(e: any) => onNumberFieldChange(e, 'empty53Qty')}
                    />
                </div>
            </div>
        </>
    )
}